/**
 * Performance Testing Configuration
 *
 * This file allows you to disable various features to isolate performance issues.
 *
 * Configuration is read from environment variables (.env files):
 * - REACT_APP_PERF_DISABLE_WEBSOCKETS: Set to 'true' to disable all WebSocket connections
 * - REACT_APP_PERF_DISABLE_REACT_QUERY_REFETCH: Set to 'true' to disable all automatic refetching
 * - REACT_APP_PERF_DISABLE_BACKGROUND_SYNC: Set to 'true' to disable 30-second background wallet sync
 * - REACT_APP_PERF_DISABLE_SLEEP_WAKE_DETECTION: Set to 'true' to disable sleep/wake UI refresh
 * - REACT_APP_PERF_DISABLE_PAGE_ANIMATIONS: Set to 'true' to disable page transition animations
 * - REACT_APP_PERF_ENABLE_LOGGING: Set to 'true' to enable performance test logging
 *
 * Usage:
 * 1. Update the environment variables in your .env file
 * 2. Restart the dev server
 * 3. Test performance
 * 4. Re-enable features one by one to identify the bottleneck
 */

// Helper function to parse boolean from environment variable
const parseEnvBoolean = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return value === 'true' || value === '1';
};

export const PERFORMANCE_TEST_CONFIG = {
  // Disable all WebSocket connections (socket.io)
  DISABLE_WEBSOCKETS: parseEnvBoolean(
    process.env.REACT_APP_PERF_DISABLE_WEBSOCKETS,
    false
  ),

  // Disable React Query automatic refetching
  DISABLE_REACT_QUERY_REFETCH: parseEnvBoolean(
    process.env.REACT_APP_PERF_DISABLE_REACT_QUERY_REFETCH,
    false
  ),

  // Disable background wallet sync (runs every 30 seconds on trading pages)
  DISABLE_BACKGROUND_SYNC: parseEnvBoolean(
    process.env.REACT_APP_PERF_DISABLE_BACKGROUND_SYNC,
    false
  ),

  // Disable sleep/wake detection and forced UI refresh
  DISABLE_SLEEP_WAKE_DETECTION: parseEnvBoolean(
    process.env.REACT_APP_PERF_DISABLE_SLEEP_WAKE_DETECTION,
    false
  ),

  // Disable page transition animations (animate.css)
  DISABLE_PAGE_ANIMATIONS: parseEnvBoolean(
    process.env.REACT_APP_PERF_DISABLE_PAGE_ANIMATIONS,
    false
  ),

  // Log when features are disabled
  ENABLE_LOGGING: parseEnvBoolean(
    process.env.REACT_APP_PERF_ENABLE_LOGGING,
    false
  ),
};

// Helper function to log when features are disabled
export const logPerformanceTest = (feature, status) => {
  if (PERFORMANCE_TEST_CONFIG.ENABLE_LOGGING) {
    console.log(`🧪 PERFORMANCE TEST: ${feature} is ${status ? 'DISABLED' : 'ENABLED'}`);
  }
};

